import { c as _c } from "react/compiler-runtime";
import type { Flag } from '../types';
import { Actions } from './actions';
import css from './controls.module.scss';
import { New } from './new';
import { Stats } from './stats';
interface Props {
  flags: Flag[];
}
export function Controls(t0) {
  const $ = _c(6);
  const {
    flags
  } = t0;
  let t1;
  if ($[0] !== flags) {
    t1 = <Stats flags={flags} />;
    $[0] = flags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <New />;
    t3 = <Actions />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={css.controls}>{t1}{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}